<template>
  <div class="invoice-container">
    <van-nav-bar title="开票" left-arrow @click-left="goBack" />
    <div class="content-container">
      <van-form :show-error-message="false" @submit="onSubmit">
        <div class="basic-info-container">
          <van-field required name="type" label="抬头类型">
            <template #input>
              <van-radio-group v-model="formData.type" direction="horizontal">
                <van-radio name="1" icon-size="14px">个人</van-radio>
                <van-radio name="2" icon-size="14px">单位</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            required
            v-model="formData.buyerName"
            name="buyerName"
            :label="labels.buyerName"
            :placeholder="placeholders.buyerName"
            :rules="buyerNameRules"
          />
          <van-field
            v-model="formData.buyerTaxNum"
            name="buyerTaxNum"
            :required="formData.type === '2'"
            :label="labels.buyerTaxNum"
            :placeholder="placeholders.buyerTaxNum"
            :rules="buyerTaxNumRules"
          />
          <van-field
            v-model="formData.buyerAddress"
            name="buyerAddress"
            :label="labels.buyerAddress"
            :placeholder="placeholders.buyerAddress"
          />
          <van-field
            v-model="formData.buyerTel"
            name="buyerTel"
            :label="labels.buyerTel"
            :placeholder="placeholders.buyerTel"
          />
          <van-field
            v-model="formData.buyerAccount"
            name="buyerAccount"
            label="银行账户"
            placeholder="请输入银行账户"
          />
        </div>
        <div class="summary-container">
          <div>
            <span class="summary-label">总金额：</span>
            <span class="summary-amount">{{ summaryAmount }}元</span>
          </div>
          <div class="summary-order-count">
            {{ pageQuery.ids.length }}个订单
          </div>
        </div>
        <div class="push-info-container">
          <van-field required name="pushMode" label="推送类型">
            <template #input>
              <van-radio-group
                v-model="formData.pushMode"
                direction="horizontal"
              >
                <van-radio :name="0" icon-size="14px">邮箱</van-radio>
                <van-radio :name="1" icon-size="14px">手机号</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            required
            v-model="formData[fieldNames.contactName]"
            :name="fieldNames.contactName"
            :label="labels.contactName"
            :placeholder="placeholders.contactName"
            :rules="contactNameRules"
          />
        </div>
        <div class="submit-btn-container">
          <van-button type="info" class="submit-btn" html-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { NavBar, Form, Field, RadioGroup, Radio, Button, Toast } from 'vant';
import { invoiceVerify, invoice } from '@/api/api';
export default {
  name: 'Invoice',
  components: {
    VanNavBar: NavBar,
    VanForm: Form,
    VanField: Field,
    VanRadioGroup: RadioGroup,
    VanRadio: Radio,
    VanButton: Button,
  },
  data() {
    return {
      pageQuery: {},
      formData: {
        type: '1',
        pushMode: 0,
      },
      summaryAmount: '0.00',
    };
  },
  computed: {
    labels() {
      const { type, pushMode } = this.formData;
      const isCompany = type === '2';
      return {
        buyerName: isCompany ? '公司名称' : '个人姓名',
        buyerTaxNum: isCompany ? '公司税号' : '纳税人识别号',
        buyerAddress: isCompany ? '公司地址' : '个人地址',
        buyerTel: isCompany ? '公司电话' : '个人电话',
        contactName: pushMode === 1 ? '手机号' : '邮箱地址',
      };
    },
    placeholders() {
      const {
        buyerName,
        buyerTaxNum,
        buyerAddress,
        buyerTel,
        contactName,
      } = this.labels;
      return {
        buyerName: `请输入${buyerName}`,
        buyerTaxNum: `请输入${buyerTaxNum}`,
        buyerAddress: `请输入${buyerAddress}`,
        buyerTel: `请输入${buyerTel}`,
        contactName: `请输入${contactName}`,
      };
    },
    fieldNames() {
      const { pushMode } = this.formData;
      return {
        contactName: pushMode === 1 ? 'buyerPhone' : 'email',
      };
    },
    buyerNameRules() {
      return [{ required: true, message: `请输入${this.labels.buyerName}` }];
    },
    buyerTaxNumRules() {
      if (this.formData.type === '2') {
        return [
          { required: true, message: `请输入${this.labels.buyerTaxNum}` },
        ];
      }
      return [];
    },
    contactNameRules() {
      return [{ required: true, message: `请输入${this.labels.contactName}` }];
    },
  },
  beforeMount() {
    this.pageQuery = this.$route.query;
    this.init();
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    async onSubmit(values) {
      Toast.allowMultiple();
      const loading = Toast.loading({
        message: '开票中...',
        duration: 0,
      });
      await invoice({ ...values, ids: this.pageQuery.ids }).finally(() => {
        loading.clear();
      });
      this.$nextTick(() => {
        Toast.success('开票成功');
        this.goBack();
      });
    },
    async init() {
      const {
        data: { total_pay_fee },
      } = await invoiceVerify(this.pageQuery);

      if (typeof total_pay_fee === 'number') {
        this.summaryAmount = total_pay_fee.toFixed(2);
      } else {
        this.summaryAmount = total_pay_fee;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;

  .content-container {
    flex: 1;
    width: 100%;
    height: 100%;
    padding-top: 10px;
    overflow-y: scroll;

    .basic-info-container,
    .push-info-container {
      margin: 0 10px;
      border-radius: 8px;
      overflow: hidden;
    }
    .summary-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      margin: 10px;
      background-color: #fff;
      border-radius: 8px;

      .summary-label {
        font-size: 14px;
      }

      .summary-amount {
        color: red;
        font-weight: bold;
      }

      .summary-order-count {
        font-size: 14px;
        color: #999;
      }
    }

    .submit-btn-container {
      width: 100%;
      padding: 10px;
      box-sizing: border-box;

      .submit-btn {
        width: 100%;
        border-radius: 8px;
      }
    }
  }
}
</style>
